export const ONBOARDING_COMPLETED = 'Onboarding completed';
export const JOB_CREATED = 'Job created';
export const JOB_SCHEDULED = 'Job scheduled';
export const JOB_COMPLETED = 'Job completed';
export const OMW_TEXT_SENT = 'OMW text sent';
export const LINE_ITEMS_UPDATED = 'Line items updated';
export const INVOICE_SENT = 'Invoice sent';
export const ONBOARDING_SUBMITTED_INFORMATION = 'Submitted information';
export const DIALOG_VIEWED = 'Dialog viewed';
export const JOB_PAID = 'Job paid';
export const ONLINE_BOOKING_ENABLED = 'Online booking enabled';
export const BANK_ACCOUNT_SETUP = 'Bank account setup';
export const CUSTOMER_ADDED = 'Customer added';
export const PRICELIST_ADDED = 'Pricelist added';
export const PRICELIST_UPDATED = 'Pricelist updated';
export const EMPLOYEE_ADDED = 'Employee added';
export const EMPLOYEE_DELETED = 'Employee deleted';
export const DEBIT_CARD_ADDED = 'Debit card added';
export const CLICK = 'Click';
export const CHECKBOX_CLICK = 'Checkbox click';
export const WEBSITE_CREATED = 'Website created';
export const PROPOSAL_OPTION_IMAGE_ADDED = 'Proposal option image added';
export const PROPOSAL_OPTION_TITLE_ADDED = 'Proposal option title added';
export const PROPOSAL_OPTION_DESCRIPTION_ADDED = 'Proposal option description added';
export const PROPOSAL_OPTION_CREATED = 'Proposal option created';
export const PROPOSAL_CREATED = 'Proposal created';
export const PROPOSAL_TITLE_ADDED = 'Proposal title added';
export const PROPOSAL_SENT = 'Proposal sent';
export const PROPOSAL_PRESENTED = 'Proposal presented';
export const PERMISSION_STATUS_CHANGED = 'Device permission status changed';
export const TRIAL_EXTENDED = 'Trial extended';
export const VIEWED_REPORT = 'Viewed report';
export const MODIFIED_REPORT = 'Modified report';
export const EXPANDED_ITEM = 'Expanded item';
export const DELETED_ITEM = 'Deleted item';
export const BETA_FEATURE_TOGGLED = 'Beta feature toggled';
export const CUSTOMER_SENT = 'Customer sent';
export const TOOLTIP_OPENED = 'Tooltip opened';
export const CUSTOMER_SERVICE_AGREEMENT_FORM_OPENED = 'Customer service agreement form opened';
export const NEW_CUSTOMER_SERVICE_AGREEMENT_FORM_OPENED = 'New Customer service agreement form opened';
export const CREATE_CUSTOMER_SERVICE_AGREEMENT_SETUP_PLAN = 'Create customer service agreement setup plan';
export const CUSTOMER_SERVICE_AGREEMENT_DETAILS = 'Customer service agreement details';
export const PLAN_SELECTED = 'Plan selected';
export const CUSTOM_SMS_NUMBER_SELECTED = 'Custom sms number selected';
export const CUSTOM_SMS_MESSAGE_UPDATED = 'Custom sms message updated';
export const COMPANY_LOGO_ADDED = 'Company logo added';
export const REVIEWS_CONFIGURATION_UPDATED = 'Reviews configuration updated';
export const BUSINESS_HOURS_UPDATED = 'Business hours updated';
export const VIRAL_LOOP_LAUNCHED = 'Viral loop launched';
export const REFERRAL_SENT = 'Referral sent';
export const SERVICE_AREA_EDITED = 'Service area edited';
export const EQUIPMENT_CREATED = 'Equipment created';
export const EQUIPMENT_ADDED = 'Equipment added';
export const EQUIPMENT_REMOVED = 'Equipment removed';
export const ACTIVTY_EVENT_SELECTED = 'Activity event selected';
export const REVIEW_REQUESTED = 'Review requested';
export const ERROR_ENCOUNTERED = 'Error encountered';
export const VIRTUAL_MEETING_STARTED = 'Virtual meeting started';
export const CHECKLIST_ADDED = 'Checklist added';
export const CHECKLIST_COMPLETED = 'Checklist completed';
export const EMAIL_BLAST_SENT = 'Email blast sent';
export const PAY_BILL_BY_ACH = 'pay bill by ach';
export const REPORT_SAVED = 'Report saved';
export const ITEM_ADDED = 'Item added';
export const ORDER_VIEWED = 'Order viewed';
export const ADD_PURCHASE_ORDER = 'add purchase order';
export const CART_VIEWED = 'Cart viewed';
export const ORDER_UPDATED = 'Order updated';
export const CHECKOUT_INITIATED = 'Checkout initiated';
export const ORDER_COMPLETED = 'Order completed';
export const VIEWED_SEND_FINANCING_APPLICATION_BANNER = 'Viewed send financing application banner';
export const LENDING_QUICKSEND_SENT = 'Lending quicksend sent';
export const LENDING_QUICKSEND_INITIATED = 'Lending quicksend initiated';
export const DRAFT_REMOVED = 'Draft removed';
export const VIDEO_WATCHED = 'Video watched';
export const STORE_LOCATION_CHANGED = 'Store location changed';
export const JOB_STARTED = 'Job started';
export const REPORT_EXPORTED = 'Report exported';
export const ACTION_UNDONE = 'Job action undone';
export const BANNER_VIEWED = 'Banner viewed';
export const LINE_ITEM_ADDED_V2 = 'Line item added v2';
export const EXPERIMENT_VIEWED = 'Experiment viewed';
export const BILLING_RECEIPT_VIEWED = 'receipt viewed';
export const OPENED_VISUAL_PRICE_BOOK = 'Opened visual price book';
export const FILTER_APPLIED = 'Filter applied';
export const SORT_APPLIED = 'Sort applied';
export const LINK_CLICKED = 'Link clicked';
export const SUBMIT = 'Submit';
export const REDIRECT_TO_MULTI_METRIC_REPORTING = 'Redirect to multi metric reporting';
export const ADD_SERVICE_PLAN_VISIT_TO_JOB_BUTTON_CLICKED = 'Add service plan visit to job button clicked';
export const PRO_MANAGED_CONFIRMED = 'Pro manage confirmed';
export const REPORT_RESIZED = 'Report resized';
export const REPORT_REMOVED = 'Report removed';
export const DASHBOARD_DATE_RANGE_MODIFIED = 'Dashboard date range modified';
export const REPORT_MOVED = 'Report moved';
export const REPORT_PRESENTED = 'Report presented';
export const REPORT_ADDED = 'Report added';
export const DASHBOARD_CREATED = 'Dashboard created';
export const DASHBOARD_DELETED = 'Dashboard deleted';
export const DASHBOARD_VIEWED = 'Reporting dashboard viewed';
export const REPORT_SHARED = 'Report shared';
export const REPORT_SCHEDULED = 'Report scheduled';
